import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import * as actions from './record.actions';
import * as selectors from './record.selectors';

import * as applicationSelectors from '../../application.selectors';
import {setPageTitle, raiseError} from '../../application.actions';
import * as irrSampleSelectors from '../irr-sample/irr-sample.selectors';
import * as irrSampleActions from '../irr-sample/irr-sample.actions';
import {
  CommentsForm,
  Documentation,
  FormControls,
  Level1Form,
  Level2Form,
  RecordInfo,
  RecordUploadInfo,
  ResidentReviewForm,
  ReviewDetails,
  IrrReviewForm
} from "./components";
import AttendingPhysician from "./components/AttendingPhysician";
import {Tab, Tabs} from "../../components";
import { FormManager } from './components/forms/FormManager';
import * as recordStatus from './record.status';
import fileSaver from 'file-saver';
import { timingSafeEqual } from 'crypto';
import {WarningButton, DefaultButton, Modal} from "../../components";

class RecordContainer extends React.Component {

  state = {
    form: FormManager.initializeForm(),
    formHasErrors: false,
    formData: undefined,
    activeKey: 0,
    recordStatus: '',
    showModal: false, 
    file: {},
    isIrr: false,
    irrForm: FormManager.initializeIrrForm(),
    irrSampleId: '',
    irrReview: undefined
  };

  showModal = (recordId) => (file) => this.setState(({showModal: true, recordId, file}));
  hideModal = () => this.setState(({showModal: false}));

  componentDidMount() {
    const {actions: {setPageTitle, fetchReview, fetchIrrReview, fetchIrrSample}, match: { params: {recordId, irrSampleId} }} = this.props;
  
    fetchReview(recordId);

    if (irrSampleId) {
      this.setState({isIrr: true, irrSampleId});
      fetchIrrSample(irrSampleId);
      fetchIrrReview(irrSampleId, recordId);
      setPageTitle("Interrater Reliability Monitoring (IRR)");
    } else {
      setPageTitle('PASRR Review > Record Review');
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.user.id && this.props.reviewers.length > 0 && this.props.review.formData) {
      if (!this.state.formData) {
        this.setState({formData: this.props.review.formData, form: this.parseFormData(this.props.review, this.props.user.id, this.props.reviewers, this.props.record)});
      }
      if (this.props.record.recordStatus !== prevProps.record.recordStatus) {
        if ((prevProps.record.recordStatus === recordStatus.Complete && this.props.record.recordStatus === recordStatus.UploadInProgress) || this.props.record.recordStatus === recordStatus.Complete) {
          this.setState({recordStatus: this.props.record.recordStatus, formData: this.props.review.formData, form: this.parseFormData(this.props.review, this.props.user.id, this.props.reviewers, this.props.record)});
        } else {
          this.setState({recordStatus: this.props.record.recordStatus});
        }  
      }
      if (!this.state.irrReview && Object.keys(this.props.irrReview).length !== 0) {
        this.setState({irrReview: this.props.irrReview, irrForm: FormManager.patchIrrForm(this.props.irrReview)});
      }
    }
  }
  
  componentWillUnmount() {
    this.props.actions.clearIrrSample();
  }

  parseFormData = (review, userId, reviewers, record) => {
    const reviewer = reviewers.find(r => r.id === userId);
    const reviewerName = reviewer ? `${reviewer.firstName} ${reviewer.lastName}` : '';

    let form;

    if (review && review.formData !== '{}'){
      form = {...FormManager.initializeForm(reviewerName), ...JSON.parse(review.formData)};
    } else {
      form = FormManager.initializeForm(reviewerName);
    }

    if (record.recordStatus === recordStatus.Complete) {
      form = FormManager.disableForm(form);
    }

    return form;
  }

  printForm = (recordId) => async () => {
    const blob = await this.props.actions.printForm(recordId);
    fileSaver.saveAs(blob, 'PASRR Review.pdf');
  }

  uploadFile = (recordId) => file =>
    this.props.actions.uploadDocumentation(recordId, file);

  deleteFile = (recordId, file) => () => {
      this.props.actions.deleteDocumentation(recordId, file);
      this.hideModal();
  }
    

  downloadFile = (recordId) => async ({id}) => {
    const url = await this.props.actions.getDocumentationUrl(recordId, id);
    window.open(url, 'epasrr_documentation')
  };

  save = () => {
    const clearedErrorForm = FormManager.clearErrors(this.state.form);
    this.setState({form: clearedErrorForm});
    return this.props.actions.saveRecord({formData: clearedErrorForm, compliant: false});
  }

  complete = () => {
    const validatedForm = FormManager.validateRequiredFields(this.state.form);
    const formHasErrors = FormManager.formHasErrors(validatedForm);
    this.setState({formHasErrors, form: validatedForm});

    if (formHasErrors) {
      return this.props.actions.raiseError('There are errors on form.');
    } else {
      return this.props.actions.saveRecord({formData: this.state.form, compliant: false, complete: true});   
    }    
  }
  
  setToInProgress = () => this.props.actions.changeRecordStatus('Upload In Progress');
  
  completeClose = () => {
    if (!FormManager.formHasErrors(this.state.form)) {
      this.props.history.goBack();
    }
  }

  saveIrr = () => {
    const {irrSampleId, irrForm} = this.state;
    const {record} = this.props;
    return this.props.actions.saveIrrReview(record.periodId, irrSampleId, record.id, irrForm);
  }

  afterIrrSave = () => this.props.history.goBack();

  changeFormValue = name => value => {
    this.setState(state => ({
      form: FormManager.onChange(name, value, state.form)
    }), () => console.log('form', this.state.form));
  }

  changeIrrFormValue = name => value => {
    this.setState(state => ({
      irrForm: FormManager.onIrrFormChange(name, value, state.irrForm)
    }), () => console.log('irrForm', this.state.irrForm));
  }

  savePhysicianName = name => this.props.actions.saveAttendingPhysician(name);

  renderModal() {
    const {showModal, recordId, file} = this.state;
    return (
      <Modal
        show={showModal}
        title="Delete File"
        onClose={this.hideModal}
        body={<div>Are you sure you want to delete {file ? file.fileName : ''}?</div>}
        footer={
          <React.Fragment>
            <DefaultButton onClick={this.hideModal}>Cancel</DefaultButton>
            <WarningButton onClick={this.deleteFile(recordId, file)}>Yes</WarningButton>
          </React.Fragment>
        }
      />
    )
  }

  render() {
    const {period, record, reviewers, documentation, roles, history, actions, user, irrType} = this.props;
    const {form, isIrr, irrForm} = this.state;

    const activeKey = isIrr ? 5 : 0;

    return (
      <div>
        <RecordInfo
          period={period}
          record={record}
          editable={roles.admin}
          onSave={actions.updateRecord}
        />
        <AttendingPhysician name={record.attendingPhysician ? record.attendingPhysician : ''} onSave={this.savePhysicianName} onChange={this.changeFormValue} onPrintForm={this.printForm(record.id)}/>
        <ReviewDetails
          record={record}
          reviewers={reviewers}
          onReviewerChange={x => console.log('change reviewer', x)}
          form={form}
          onChange={this.changeFormValue}
          user={user}
        />
        <Tabs activeKey={activeKey}>
          <Tab text="Level 1" render={() => <Level1Form form={form} onChange={this.changeFormValue}/>}/>
          <Tab text="Level 2" render={() => <Level2Form form={form} onChange={this.changeFormValue}/>}/>
          <Tab text="Resident Review" render={() => <ResidentReviewForm form={form} onChange={this.changeFormValue}/>}/>
          <Tab text="Comments" render={() => <CommentsForm form={form} onChange={this.changeFormValue}/>}/>
          <Tab
            text="Attachments"
            render={() =>
              <Documentation
                roles={roles}
                record={record}
                documentation={documentation}
                onUpload={this.uploadFile(record.id)}
                onDelete={this.showModal(record.id)}
                onFileClick={this.downloadFile(record.id)}
              />}
          />
          <Tab text="IRR" render={() => <IrrReviewForm type={irrType} form={irrForm} onChange={this.changeIrrFormValue}/>} hidden={!isIrr}/> 
        </Tabs>
        {!isIrr && <RecordUploadInfo record={record}/>}

        <FormControls
          disabled={!roles.admin && record.recordStatusValue >= 3}
          completeText="Complete"
          onClose={() => history.goBack()}
          onCompleteClose={this.completeClose}
          enableComplete= {!roles.nursingFacility || documentation.length > 0}
          onSubmit={this.complete}
          onSave={this.save}
          onSetToInProgress={this.setToInProgress}
          onIrrSave={this.saveIrr}
          afterIrrSave={this.afterIrrSave}
          showSave={!isIrr && record.recordStatus !== recordStatus.Complete}
          showComplete={!isIrr && record.recordStatus !== recordStatus.Complete}
          showSetToInProgress={!isIrr &&
            (record.recordStatus === recordStatus.Submitted || record.recordStatus === recordStatus.ReviewInProgress || record.recordStatus === recordStatus.Complete)}
          showIrrSave={isIrr}
        />

        {this.renderModal()}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    periodId: state.record.periodId,
    recordId: state.record.recordId,
    record: selectors.record(state),
    period: selectors.period(state),
    documentation: selectors.documentation(state),
    reviewers: applicationSelectors.reviewers(state),
    roles: applicationSelectors.roles(state),
    review: state.record.review,
    user: applicationSelectors.user(state),
    irrType: irrSampleSelectors.irrType(state),
    irrReview: irrSampleSelectors.irrReview(state)
  }),
  dispatch => ({
    actions: bindActionCreators({...actions, setPageTitle, raiseError, ...irrSampleActions}, dispatch)
  })
)(RecordContainer);



// WEBPACK FOOTER //
// ./src/modules/record/RecordContainer.js